import React from "react";
import { Link } from "react-router-dom";
import { Col, Row, Spinner } from "reactstrap";

const getCompany = () => {
  return localStorage.getItem("authUser") ? JSON.parse(localStorage.getItem("authUser")).data.company_name : "";
};
const BreadCrumb = ({ title, pageTitle, loading, children }) => {
  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between gap-3 py-3">
            <h4 className="mb-sm-0 fw-semibold">{`${pageTitle}`} {loading && (
              <>
                <Spinner color="primary" type="grow" size={"sm"}>
                  Loading...
                </Spinner>
                &nbsp;
                <Spinner color="success" type="grow" size={"sm"}>
                  Loading...
                </Spinner>
                &nbsp;
              </>
            )}
              <ol className="breadcrumb m-0 text-muted fw-normal fs-11 mt-1">
                <li className="breadcrumb-item">{getCompany()}</li>
                <li className="breadcrumb-item active">{title}</li>
              </ol>

            </h4>

            <div className="page-title-right">
              {children}
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default BreadCrumb;
